import { render, staticRenderFns } from "./WeblogDetails.vue?vue&type=template&id=16e2472f&scoped=true&"
import script from "./WeblogDetails.vue?vue&type=script&lang=js&"
export * from "./WeblogDetails.vue?vue&type=script&lang=js&"
import style0 from "./WeblogDetails.vue?vue&type=style&index=0&id=16e2472f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2472f",
  null
  
)

export default component.exports